import React, { MouseEventHandler } from 'react';
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';
import Zoom from '@mui/material/Zoom';
import ClickAwayListener from '@mui/base/ClickAwayListener';
import IconItemComponent from './Icon-item.component';
import { IIcon } from '@core/Icons';

interface IProps {
    iconList: IIcon[];
    onIconClick: MouseEventHandler<HTMLButtonElement>;
    onSelectIconWindowClose: (e: MouseEvent | TouchEvent) => void;
    iconSelectVisible: boolean;
    iconSelectEl: HTMLElement | null;
}

const Component: React.FC<IProps> = ({
    iconList,
    onIconClick,
    onSelectIconWindowClose,
    iconSelectVisible,
    iconSelectEl,
}: IProps) => {
    const iconListPipe = ({ name, value }: IIcon) => {
        return (
            <IconItemComponent
                name={name}
                value={value}
                onIconClick={onIconClick}
            />
        );
    };
    const list = iconList.map(iconListPipe);
    return (
        <ClickAwayListener onClickAway={onSelectIconWindowClose}>
            <Popper
                className="edit-device__icon-popper-wrap"
                placement="top"
                open={iconSelectVisible}
                anchorEl={iconSelectEl}
                container={
                    iconSelectEl ? iconSelectEl.parentElement : document.body
                }
                modifiers={[{ name: 'flip', enabled: false }]}
            >
                <Zoom in={iconSelectVisible}>
                    <Box className="edit-device__icon-popper">{list}</Box>
                </Zoom>
            </Popper>
        </ClickAwayListener>
    );
};

const IconListComponent = React.memo(Component);

export default IconListComponent;
